import {
    AnimationLoadingBaseController,
    IAnimationControllerConfiguration,
    ILoadingBaseController,
    Inject, ModelEvents,
} from '@denishussar/html5-game-engine';
import { GameEvent } from '../Constants/GameEvent';
import { GameModel } from '../Models/GameModel';

export class PreloaderGameController extends AnimationLoadingBaseController implements ILoadingBaseController {
    public $model: any;

    public constructor(@Inject private _options: any,
                       @Inject private _modelEvents: ModelEvents,
                       @Inject private _model: GameModel
    ) {
        super('PreloaderGameController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{};
    }

    protected onInitialize(): void {
    }

    protected onResize(width: number, height: number, scale: number) {
    }

    public onLoadingProgress(progress: number): void {
    }

    public onHide(): void {
    }

    public onShow(): void {
    }

    public set visible(value: boolean) {
    }
}
